const READONLY_COL = { flex: 1, minWidth: 60, headerAlign: "center", align: "center" };
const EDITABLE_COL = { flex: 1, minWidth: 80, headerAlign: "center", align: "center" };

export const mrpGridColumns = (canEdit) => [
	{ field: "category", headerName: "Category", ...READONLY_COL },
	{ field: "sub_category", headerName: "Sub Category", ...READONLY_COL },
	{ field: "sub_brand", headerName: "SUB BRAND", ...READONLY_COL },
	{ field: "attribute_value", headerName: "ATTRIBUTE", ...READONLY_COL },
	{ field: "mrp", headerName: "MRP", ...READONLY_COL },
	{ field: "ltl_qty", headerName: "PRV QTY", ...READONLY_COL },
	{
		field: "new_qty",
		headerName: "NEW QTY",
		...EDITABLE_COL,
		editable: canEdit,
		type: "number",
	},
	{
		field: "ltl_dis",
		headerName: "PRV DIS",
		...READONLY_COL,
		valueFormatter: (value) => `${value || 0}%`,
	},
	{
		field: "new_dis",
		headerName: "DIS%",
		...EDITABLE_COL,
		editable: canEdit,
		type: "number",
	},
	{
		field: "ltl_st",
		headerName: "PRV ST",
		...READONLY_COL,
		valueFormatter: (value) => `${value || 0}%`,
	},
	{
		field: "ltl_inventory_qty",
		headerName: "PRV DISP",
		...READONLY_COL,
	},
	{ field: "ltl_opt", headerName: "PRV OPT", ...READONLY_COL },
	{
		field: "new_opt",
		headerName: "NEW OPT",
		...EDITABLE_COL,
		editable: canEdit,
		type: "number",
	},
	{ field: "new_asp", headerName: "ASP", ...READONLY_COL },
	{
		field: "new_nsv",
		headerName: "NSV",
		...READONLY_COL,
		valueFormatter: (value) => Math.round(value || 0),
	},
];

export const mrpHiddenColumns = {
	category: false,
	sub_category: false,
};

export const sortMrpRows = (rows) =>
	[...(rows || [])].sort((a, b) => {
		const bySubBrand = String(a.sub_brand || "").localeCompare(String(b.sub_brand || ""), undefined, {
			sensitivity: "base",
		});
		if (bySubBrand) return bySubBrand;
		const byAttr = String(a.attribute_value || "").localeCompare(String(b.attribute_value || ""), undefined, {
			sensitivity: "base",
		});
		if (byAttr) return byAttr;
		return (Number(b.mrp) || 0) - (Number(a.mrp) || 0);
	});
